import { Component, OnInit } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { FaqService } from 'src/app/shared/services/faq.service';

@Component({
  selector: 'app-footer-evo',
  templateUrl: './footer-evo.component.html',
  styleUrls: ['./footer-evo.component.scss']
  
})
export class FooterEvoComponent implements OnInit {

  public today: Date = new Date();
  
  urlBlobPdf: SafeUrl;

  constructor(
    private faqService: FaqService
    ) { }

  ngOnInit() {
    this.urlBlobPdf = this.faqService.obterUrlBlob().subscribe(
      url => this.urlBlobPdf = url
    );
  }

}
